import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FracScheduleModel, ScheduleFilters } from '../model';
import { FormatURI, HttpService } from '../../../utility/http-service';
import { EditDialogService } from '../../../utility/dialog/edit-dialog-service';
import { LoginService } from '../../../../services/login-service';
import { SchedulesMapComponent } from '../schedules-map/schedules-map.component';
import { Router } from '@angular/router';
import { UploadConfirmationComponent } from '../upload-confirmation/upload-confirmation.component';
import { MatDialogConfig } from '@angular/material/dialog';
import { DialogService } from '../../../utility/dialog/dialog-service';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { WcGridComponent } from '../../../components/wc-grid/wc-grid.component';
import { FilterGroup, GridDefinition, LookupOption } from '../../../components/wc-grid/grid-types';
import { OpenGrid } from '../../../components/wc-grid/wc-grid-popup/wc-grid-popup.component';
import { ArchiveSchedulesComponent } from '../archive-schedules/archive-schedules.component';
import { LoadingService } from '../../../../services/loading.service';

@Component({
  selector: 'schedules-header',
  standalone: false,

  templateUrl: './schedules-header.component.html',
  styleUrl: '../schedules.scss'
})
export class SchedulesHeaderComponent implements OnInit {

  selectedFile: File | null = null;
  uploadMessage: string | null = null;
  isUploading: boolean = false;
  showUploadForm: boolean = false;

  constructor(private http: HttpService, private dialogService: EditDialogService,
    public loginService: LoginService, private router: Router, private ds: DialogService,
    private loadingService: LoadingService) {

  }
  @ViewChild('fileInput') fileInput?: ElementRef;
  activeScreen = 'map';
  summaryData: { operating: number, next7: number, next8_30: number, next31_60: number, next61_90: number, total: number }
    = { operating: 0, next7: 0, next8_30: 0, next31_60: 0, next61_90: 0, total: 0 };
  regions: string[] = [];
  stateCounties: string[] = [];
  operators : string[] = [];
  numDays = 90;
  pastDays = 0;
  searchText = "";
  filtersOpen = true;

  get hasManageOptions(): boolean {
    const u = this.loginService.user;
    return u.enableFracXAutomation || u.isGlobalAdmin || u.isCompanyAdmin || u.enableFracXContacts;
  }

  get activeFilterCount(): number {
    let count = 0;
    if (this.regions.length) count++;
    if (this.stateCounties.length) count++;
    if (this.operators.length) count++;
    if (this.numDays !== 90) count++;
    if (this.pastDays !== 0) count++;
    return count;
  }

  filters: ScheduleFilters = { operators: [], regions: [], stateCounty: [] };
  data: FracScheduleModel[] = [];

  public context: Record<string, any> = {};

  @ViewChild(WcGridComponent) grid?: WcGridComponent;
  @ViewChild(SchedulesMapComponent) map?: SchedulesMapComponent;

  ngOnInit(): void {
    this.reload();
  }

  reload(): void {
    this.loadFilters();
    this.loadData();
  }

  loadFilters(): void {
    this.http.get("FracX/FilterValues", (filters: ScheduleFilters) => {
      this.filters = filters;
    });
  }

  loadData(): void {

    this.context = {
      "operatorIds": JSON.stringify(this.operators),
      "regions": JSON.stringify(this.regions),
      "stateCounties": JSON.stringify(this.stateCounties),
      "numberDays": this.numDays,
      "pastDays": this.pastDays,
      "searchText": this.searchText
    };

    this.http.get(
      `FracX/Data?operatorIds=${JSON.stringify(this.operators)}&regions=${JSON.stringify(this.regions)}&stateCounties=${JSON.stringify(this.stateCounties)}&numberDays=${this.numDays}&pastDays=${this.pastDays}&searchText=${this.searchText}`,
      (data: FracScheduleModel[]) => {
        // Set combined result
        this.data = data;

        // Update grid
        if (this.grid) {
          this.grid.context = this.context;
          this.grid.reload(1);
        }
        else if (this.map?.map) {
          this.map.setUpSource(false, true, this.data);
          this.map.updateMarkers(this.map.map);
        }

        // Summary stats
        this.summaryData = {
          operating: 0,
          next7: 0,
          next8_30: 0,
          next31_60: 0,
          next61_90: 0,
          total: this.data.length
        };

        this.data.forEach((x: FracScheduleModel) => {
          if (x.operating) this.summaryData.operating++;
          if (x.next7) this.summaryData.next7++;
          if (x.next8_30) this.summaryData.next8_30++;
          if (x.next31_60) this.summaryData.next31_60++;
          if (x.next61_90) this.summaryData.next61_90++;
        });
      }
    );
  }
  toMap() {
    this.activeScreen = 'map';
  }

  toGrid() {
    this.activeScreen = 'list';
  }

  toCalendar() {
    this.activeScreen = 'calendar';
  }

  downloadApiDocs() {
    this.http.getFile(this.downloadFileService({}, 'FracX/DownloadApiDocumentation'), "", () => {
      this.isDownloading = false;
    });
  }
  
  isDownloading = false; //track the download state
  loadFile(): void {
    const params = {
      companyIds: this.operators,
      regionNames: this.regions,
      stateCounties: this.stateCounties,
      numberDays: this.numDays,
      pastDays: this.pastDays,
      // Lets the server stamp "Date Exported" in this user's own time rather than server UTC.
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    //Set the downloading state to true when the download starts
    this.isDownloading = true;
    this.http.getFile(this.downloadFileService(params, 'FracX/ExportToExcel'), "", () => {
      this.isDownloading = false;
    });
  }

  isDownloadingShapefile = false; //track the shapefile download state
  loadShapefile(): void {
    const params = {
      companyIds: this.operators,
      regionNames: this.regions,
      stateCounties: this.stateCounties,
      numberDays: this.numDays,
      pastDays: this.pastDays
    };

    //Set the downloading state to true when the download starts
    this.isDownloadingShapefile = true;
    this.http.getFile(this.downloadFileService(params, 'FracX/ExportToShapefile'), "", () => {
      this.isDownloadingShapefile = false;
    });
  }

  // Method to download the file
  downloadFileService(params: any, endpoint: string): string {
    
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params[key] !== undefined && params[key] !== null) {
        httpParams = httpParams.set(key, params[key].toString());
      }
    }

    return httpParams.keys().length
      ? `${endpoint}?${httpParams.toString()}`
      : endpoint;
  }
  onFileSelect(event: any): void {
    this.selectedFile = event.target.files[0];  
  }

  // Handle the upload action
  onFileUpload(): void {
    if (this.selectedFile) {
      this.uploadFile(this.selectedFile);
    }
  }

  clampDays(field: 'numDays' | 'pastDays'): void {
    if (this[field] < 0) this[field] = 0;
    if (this[field] > 500) this[field] = 500;
  }

  clearFilters(): void {
    this.regions = [];
    this.stateCounties = [];
    this.operators = [];
    this.numDays = 90;
    this.pastDays = 0;
    this.loadData();
  }

  // Upload the file to the backend
  uploadFile(file: File): void {
    const formData = new FormData();
    formData.append('file', file, file.name);

    this.isUploading = true;
    this.uploadMessage = 'Parsing schedule…';

    const opId = this.loadingService.show('Parsing schedule…', 8000);
    const uploadUrl = FormatURI('FracX/UploadExcelPreview');

    this.uploadFileService(uploadUrl, formData).subscribe(
      (response) => {
        this.loadingService.hide(opId);
        if (response.body.errorIndicator && response.body.message)
          this.ds.showError(response.body.message);
        else {
          this.dialogService.openModal(UploadConfirmationComponent, (c: MatDialogConfig) => {
            c.data = response;
            c.minWidth = "1200px";
            c.minHeight = "85vh";
            c.maxHeight = "95vh";
          });
        }
        this.isUploading = false;
        if (this.fileInput)
          this.fileInput.nativeElement.value = null;
      },
      (error) => {
        this.loadingService.hide(opId);
        this.ds.showError('Error uploading file. Please try again.');
        this.isUploading = false;
        if (this.fileInput)
          this.fileInput.nativeElement.value = null;
      }
    );
  }

  // Method to upload the file to the backend
  uploadFileService(url: string, formData: FormData): Observable<any> {
    return this.http.http.post(url, formData, {
      headers: new HttpHeaders(),
      observe: 'response'
    });
  }

  // Reset the form and button after upload
  resetForm(): void {
    this.showUploadForm = false;
    this.selectedFile = null;
    this.uploadMessage = null;
  }

  // Toggle the visibility of the upload form
  toggleUploadForm(): void {
    this.showUploadForm = !this.showUploadForm;
    if (!this.showUploadForm) {
      this.selectedFile = null;  
      this.uploadMessage = null; 
    }
  }

  goToGrid(): void {
    this.router.navigate(['/job-grid']);  
  }

  contacts() {
    OpenGrid("fracContacts", this.dialogService);
  }

  manageFracXClients() {
    OpenGrid("fracxClientMgmt", this.dialogService);
  }

  manageFracXUsers() {
    OpenGrid("fracxUserMgmt", this.dialogService, 1700, 850, true);
  }

  archiveSchedules() {
    const ref = this.dialogService.openModal(ArchiveSchedulesComponent, (c: MatDialogConfig) => {
      c.data = {};
      c.minWidth = '500px';
    });
    ref.afterClosed().subscribe((didArchive: boolean) => {
      if (didArchive) this.reload();
    });
  }

  gridMenu = [
    { id: 'review', label: 'Review' }
  ];

  public def: GridDefinition = {
    allowFilters: false,
    canCreate: false,
    canDelete: false,
    editMode: 'popup',
    columns: [
      {
        dataType: 'Date',
        field: 'reviewDate',
        header: 'Review Date',
        editable: false,
        hideOnAdd: false,
        hideOnEdit: false,
        hideInGrid: false,
        filterable: false,
        required: false,
        format: 'yyyy/MM/dd',
        readOnlyReason: null,
        sortable: false,
        cascadeLookup: false
      },
      {
        dataType: 'String',
        field: 'reviewerName',
        header: 'Reviewed By',
        editable: false,
        hideOnAdd: false,
        hideOnEdit: false,
        hideInGrid: false,
        filterable: false,
        required: false,
        readOnlyReason: null,
        sortable: false,
        cascadeLookup: false
      },
      {
        dataType: 'String',
        field: 'comments',
        header: 'Comments',
        editable: true,
        hideOnAdd: false,
        hideOnEdit: false,
        hideInGrid: false,
        filterable: false,
        required: true,
        readOnlyReason: null,
        sortable: false,
        cascadeLookup: false
      },
      {
        dataType: 'String',
        field: 'riskLevel',
        header: 'Risk Level',
        editable: true,
        hideOnAdd: false,
        hideOnEdit: false,
        hideInGrid: false,
        filterable: false,
        required: true,
        readOnlyReason: null,
        sortable: false,
        cascadeLookup: false,
        lookupKey: 'RiskLevel'
      }
    ],
    gridEditable: true,
    gridKey: 'fracReview',
    idField: 'Id',
    showHeader: false,
    sendAllColumns: true,
    softDelete: false,
    title: 'Edit Frac Review',
    titlePlural: 'Edit Frac Review'
  }

  public editorOpen = false;

  public editorModel: any = {};
  public filter: FilterGroup = { logic: 'AND', rules: [], groups: [] };
  public editorMode:'edit'|'create' = 'edit';
  public editorTitle = 'Edit Frac Review';

  public lookups: Record<string, LookupOption[]> = {
    "RiskLevel": [
      { label: 'None', value: 'None' },
      { label: 'High', value: 'High' },
      { label: 'Medium', value: 'Medium' },
      { label: 'Low', value: 'Low' }
    ]
  }
  

  onEditorSave(model: Record<string, any>) {
    this.http.post('FracX/UpdateReview', () => {
      this.editorOpen = false;
      this.editorModel = {};
    }, {
      companyId: model['companyId'],
      api: model['api'],
      riskLevel: model['riskLevel'],
      comments: model['comments']
    }, null)
  }

  closeEditor() {
    this.editorOpen = false;
    this.editorModel = {};
  }

  onGridMenu(e: { id: string; row: Record<string, any> }) {
    switch (e.id) {
      case 'review':
        if (e.row) {
          let api: string = e.row['Api'];
          this.http.get(`FracX/LastReviewByApi?companyId=${e.row['CompanyId']}&api=${api}`, (res: any) => {
            this.editorModel = res;
            this.editorOpen = true;
          })
        }
        break;
    }
  }
}
